const DATA_TEST_IDS = {
  headerStripe: 'main-layout__header-stripe',
};

export default DATA_TEST_IDS;
